<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Institución"
            rules="required"
          >
            <b-form-group
              label="Institución"
              label-for="institucion"
              :state="getValidationState(validationContext)"
            >
              <b-form-select
                v-model="institucion"
                type="select"
                class="custom-select"
                @change="onChangeInstitucion"
              >
                <option
                  value=""
                >
                  SELECCIONE::
                </option>
                <option
                  v-for="inst in optionInstitucion"
                  :key="inst.idInstitucion"
                  :value="inst.idInstitucion"
                >
                  {{ inst.nombre }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="perfil"
            rules="required"
          >
            <b-form-group
              label="Perfil"
              label-for="perfil"
              :state="getValidationState(validationContext)"
            >
              <b-form-select
                v-model="perfil"
                type="select"
                class="custom-select"
                @change="onChangePerfil"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option
                  v-for="perf in optionPerfil"
                  :key="perf.idPerfil"
                  :value="perf.idPerfil"
                >
                  {{ perf.nombre }}
                </option>
              </b-form-select>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Dependencia"
            label-for="proyecto"
          >
            <b-form-select
              v-model="proyecto"
              type="select"
              class="custom-select"
              :disabled="disabledProyecto"
            >
              <option value="">
                TODOS::
              </option>
              <option
                v-for="proy in optionProyecto"
                :key="proy.idProyecto"
                :value="proy.idProyecto"
              >
                {{ proy.nombre }}
              </option>
            </b-form-select>
          </b-form-group>
          <validation-provider
            #default="validationContext"
            name="dni"
            rules="required"
          >
            <b-form-group
              label="Dni"
              label-for="dni"
            >
              <b-input-group>
                <b-form-input
                  id="dni"
                  v-model="formData.dni"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
                />
                <b-input-group-append
                  @click="validarDocumento()"
                >
                  <b-button
                    variant="outline-primary"
                  >
                    <feather-icon
                      icon="SearchIcon"
                      size="14"
                      class="align-middle text-body"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div
            v-if="isBusyReniec"
            class="text-center text-primary my-2"
          >
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombres"
              label-for="nombre"
            >
              <b-form-input
                id="nombre"
                v-model="formData.nombre"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="ApellidoPaterno"
            rules="required"
          >
            <b-form-group
              label="Apellido Paterno"
              label-for="ApellidoPaterno"
            >
              <b-form-input
                id="ApellidoPaterno"
                v-model="formData.apellidoPaterno"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="ApellidoMaterno"
            rules="required"
          >
            <b-form-group
              label="Apellido Materno"
              label-for="ApellidoMaterno"
            >
              <b-form-input
                id="ApellidoMaterno"
                v-model="formData.apellidoMaterno"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Email"
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="formData.email"
              trim
            />
          </b-form-group>
          <b-form-group
            v-show="false"
            label="Meta"
            label-for="meta"
          >
            <b-form-input
              id="meta"
              v-model="formData.meta"
              trim
              @keypress="onlyNumbers($event)"
            />
          </b-form-group>
          <validation-provider
            #default="validationContext"
            name="login"
            rules="required"
          >
            <b-form-group
              label="Usuario"
              label-for="login"
            >
              <b-form-input
                id="login"
                v-model="formData.login"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            v-if="formEditStatus !== true"
            label="Contraseña"
            label-for="password"
          >
            <b-form-input
              id="password"
              v-model="formData.password"
              type="password"
              trim
            />
          </b-form-group>
          <b-form-group
            v-show="false"
          >
            <label class="col-sm-8 control-label">Responsable</label>
            <div
              class="col-sm-4 text-right"
              style="display:inline-block !important"
            >
              <b-form-checkbox
                v-model="formData.responsable"
                checked="true"
                name="check-button"
                switch
                inline
              />
            </div>
          </b-form-group>
          <b-form-group
            label="Fecha Alta"
            label-for="fechaAlta"
          >
            <b-form-datepicker
              id="fechaAlta"
              v-model="formData.fechaAlta"
              class="mb-1"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es"
              placeholder="Selecccione fecha"
            />
          </b-form-group>
          <b-form-group
            label="Fecha Baja"
            label-for="fechaBaja"
          >
            <b-form-datepicker
              id="fechaBaja"
              v-model="formData.fechaBaja"
              class="mb-1"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es"
              placeholder="Selecccione fecha"
            />
          </b-form-group>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BSpinner, BFormInput, BFormInvalidFeedback, BButton, BFormSelect, BInputGroup, BInputGroupAppend, BFormDatepicker, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import store from '@/store'
import { useNotify } from '@/helpers/toast'
import { onlyNumbers } from '@/helpers'

export default {
  components: {
    BSidebar,
    BSpinner,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const isBusyReniec = ref(false)
    const isBusy = ref(false)
    const metaShow = ref(false)
    const disabledProyecto = ref(false)
    const blankData = {
      idUsuario: 0,
      apellidoMaterno: '',
      apellidoPaterno: '',
      dni: '',
      email: '',
      fechaAlta: moment().format('YYYY-MM-DD'),
      fechaBaja: '',
      login: '',
      foto: '',
      nombre: '',
      password: '123456',
      responsable: false,
      meta: 0,
    }
    const optionInstitucion = ref('')
    const institucion = ref('')
    const proyecto = ref('')
    const optionProyecto = ref('')
    const optionPerfil = ref('')
    const formEditStatus = ref(false)
    const perfil = ref('')
    const titleForm = ref('')
    const userData = ref(JSON.parse(localStorage.getItem('userData')))

    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }
    const onSubmit = () => {
      isBusy.value = true
      let bval = true
      formData.value.institucion = {
        idInstitucion: institucion.value,
      }
      formData.value.proyecto = {
        idProyecto: (proyecto.value === '') ? 0 : proyecto.value,
      }
      if (proyecto.value === '' && (perfil.value !== 2 && perfil.value !== 7)) { // administrador, gerente
        notify('Advertencia', 'Seleccione una dependencia', 'warning')
        bval = false
        isBusy.value = false
      }
      if (bval) {
        formData.value.perfil = {
          idPerfil: perfil.value,
        }
        let service = 'seguridad/USUARIO_CREATE'
        if (props.formType === 'edit') {
          service = 'seguridad/USUARIO_UPDATE'
        }
        store.dispatch(service, formData.value)
          .then(response => {
            isBusy.value = false
            context.emit('refetch-data', response)
            context.emit('update:is-add-new-user-sidebar-active', false)
          })
          .catch(error => {
            isBusy.value = false
            notify('Ha ocurrido un error', error.response.data.errorMessage, 'danger')
            // context.emit('error-data', error)
            // context.emit('update:is-add-new-user-sidebar-active', false)
          })
      }
    }

    const dataForm = () => {
      store
        .dispatch('gsencuesta/INSTITUCION_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
        })
        .then(response => {
          if (response !== undefined) {
            optionInstitucion.value = response
            institucion.value = userData.value.idInstitucion
          }
        })
        .catch(error => {
          notify(error, 'He ocurrido un error', 'danger')
        })
      store
        .dispatch('seguridad/PERFIL_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
        })
        .then(response => {
          if (response !== undefined) {
            optionPerfil.value = response
          }
        })
        .catch(error => {
          notify(error, 'He ocurrido un error', 'danger')
        })
    }
    const dataProyecto = () => {
      store
        .dispatch('gsencuesta/PROYECTO_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
          idInstitucion: institucion.value,
        })
        .then(response => {
          if (response !== undefined) {
            optionProyecto.value = response
          }
        })
        .catch(() => {
        })
    }
    const onChangeInstitucion = () => {
      proyecto.value = ''
      if (perfil.value === 2 || perfil.value === 7) {
        disabledProyecto.value = true
      } else {
        disabledProyecto.value = false
      }
      dataProyecto(institucion.value)
    }
    const onChangePerfil = () => {
      if (perfil.value === 2 || perfil.value === 7) {
        proyecto.value = ''
        disabledProyecto.value = true
      } else {
        disabledProyecto.value = false
        dataProyecto()
      }
    }
    const validarDocumento = () => {
      if (formData.value.dni !== '') {
        isBusyReniec.value = true
        store
          .dispatch('gsencuesta/ENCUESTADO_FIND_ALL_RENIEC', {
            dni: formData.value.dni,
          })
          .then(res => {
            const dataReniec = res.datosPersona === undefined ? [] : res.datosPersona
            formData.value.nombre = dataReniec.prenombres
            formData.value.apellidoPaterno = dataReniec.apPrimer
            formData.value.apellidoMaterno = dataReniec.apSegundo
            formData.value.foto = dataReniec.foto
            formData.value.login = formData.value.dni
            isBusyReniec.value = false
          })
          .catch(error => {
            notify('Advertencia', error.response.data.errorMessage, 'warning')
            isBusyReniec.value = false
          })
      }
    }
    const toggleSidebar = async val => {
      dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      institucion.value = ''
      perfil.value = ''
      proyecto.value = ''
      disabledProyecto.value = false
      if (props.formType === 'new') {
        titleForm.value = 'Nuevo Usuario'
      }
      formEditStatus.value = false
      if (props.formType === 'edit') {
        formEditStatus.value = true
        formData.value = {
          idUsuario: props.dataEdit.idUsuario,
          nombre: props.dataEdit.nombre,
          apellidoPaterno: props.dataEdit.apellidoPaterno,
          apellidoMaterno: props.dataEdit.apellidoMaterno,
          dni: props.dataEdit.dni,
          email: props.dataEdit.email,
          fechaAlta: props.dataEdit.fechaAlta,
          fechaBaja: props.dataEdit.fechaBaja,
          responsable: props.dataEdit.responsable,
          login: props.dataEdit.login,
          foto: props.dataEdit.foto,
          meta: props.dataEdit.meta,
        }
        if (props.dataEdit.institucion.idInstitucion === 0) {
          institucion.value = ''
        } else {
          institucion.value = props.dataEdit.institucion.idInstitucion
        }
        perfil.value = props.dataEdit.perfil.idPerfil
        titleForm.value = 'Editar Usuario'
        if (props.dataEdit.proyecto !== null) {
          await onChangeInstitucion(institucion.value)
          proyecto.value = (props.dataEdit.proyecto.idProyecto === 0) ? '' : props.dataEdit.proyecto.idProyecto
        }
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      optionInstitucion,
      institucion,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      toggleSidebar,
      titleForm,
      validarDocumento,
      isBusyReniec,
      optionPerfil,
      perfil,
      formEditStatus,
      isBusy,
      metaShow,
      proyecto,
      optionProyecto,
      dataProyecto,
      onChangeInstitucion,
      userData,
      onChangePerfil,
      disabledProyecto,
    }
  },
  methods: {
    onlyNumbers,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
